import React from 'react';
import AvatarBadgeChip from './AvatarBadgeChip';

function LobbyUserAvatar({
  username,
  avatarUrl,
  isHost = false,
  size = 22,
}) {
  const label = username || '?';
  const initial = label.charAt(0).toUpperCase();

  const avatarEl = avatarUrl ? (
    <img
      src={avatarUrl}
      alt=""
      className="lobby-user-avatar-img"
      style={{ width: size, height: size }}
      title={label}
    />
  ) : (
    <span
      className="lobby-user-avatar-placeholder"
      style={{ width: size, height: size }}
      title={label}
    >
      {initial}
    </span>
  );

  return (
    <span className="lobby-user-avatar-wrap" style={{ width: size, height: size }}>
      {avatarEl}
      {isHost && <AvatarBadgeChip kind="host" />}
    </span>
  );
}

export default LobbyUserAvatar;